export default {
	termsAndConditions: {
		lastUpdate: 'Senast uppdaterad: 10 juni 2024',
		content: `
		<p>Villkoren du hittar nedan är viktiga eftersom:</p>
		<ul>
			<li>De etablerar sina juridiska rättigheter i {siteName}.</li>
			<li>Förklara vilka rättigheter du ger oss när du använder {siteName}.</li>
			<li>
				De beskriver reglerna som alla måste respektera när de använder {siteName}.
			</li>
		</ul>
		<p>
			Läs dessa villkor noggrant, samt vår {privacyPolicyLink} och alla andra
			dokument som nämns i dessa villkor.
		</p>
		<p>Låt oss komma igång...</p>
		<h3>1. INTRODUKTION OCH DATA FÖR {siteNameUpper}.</h3>
		<p>
			Webbplatsen {websiteLink} (hädanefter "Webbplatsen") ägs av företaget
			{siteName} S.L (hädanefter "{siteName}"), ett företag
			införlivat i enlighet med spansk lagstiftning med adress på Avenida de
			Cerdanyola, nº 75, 1º, Sant Cugat del Vallès (Barcelona), innehavare av CIF-nummer
			B-56.768.260 och registrerat i Barcelonas Mercantile Registry i volym
			49065, Folio 0033, Blad B-606324, 1:a registreringen.
		</p>
		<p>
			{siteName} ställer webbplatsen till ditt förfogande så att du kan komma till
			känna oss bättre, känna till de tjänster vi tillhandahåller och om du vill kan du kontakta
			och, där så är lämpligt, avtal med oss.
		</p>
		<h3>2. SYFTE OCH TILLÄMPNINGSOMRÅDE FÖR ANVÄNDARVILLKOR</h3>
		<p>
			Dessa användningsvillkor utgör tillsammans med {privacyPolicyLink} och
			{cookiesPolicyLink}, det juridiska ramverket som reglerar användningen av webbplatsen
			{websiteLink}. Dessa användningsvillkor kommer att finnas tillgängliga för dig på webbplatsen
			på engelska så att du kan konsultera, arkivera eller skriva ut dem när som helst och
			när du vill.
		</p>
		<p>
			För att få några frågor angående behandlingen som utförs av {siteName}.
			av dina personuppgifter, besök vår {privacyPolicyLink} och vår {cookiesPolicyLink}.
			Båda policyerna kommer också att vara tillgängliga för dig på engelska så att du kan
			konsultera, arkivera eller skriva ut dem när som helst.<br />
			{siteName} använder cookies från tredje part på webbplatsen. För att få reda på mer
			om vilken typ av cookies som används på webben {websiteLink}, deras syfte och hur
			för att konfigurera din webbläsare om du inte vill att vi ska använda dessa cookies,
			besök vår {cookiesPolicyLink}.
		</p>
		<p>
			Båda dessa användningsvillkor, såväl som {privacyPolicyLink} och 
			{cookiesPolicyLink} har utarbetats i enlighet med bestämmelserna i nuvarande
			tillämpliga bestämmelser, bland annat lagen 34/2002, om tjänster av
			Informationssamhället och elektronisk handel och förordning (EU) 2016/679 av
			Europaparlamentet och rådet den 27 april 2016 angående
			skydd för fysiska personer när det gäller behandling av personliga
			uppgifter och den fria rörligheten för dessa uppgifter och genom vilket direktiv 95/46/EG
			upphävs.
		</p>
		<h3>3. ÅTKOMST TILL WEBBPLATSEN OCH ACCEPTERANDE</h3>
		<p>
			Tillgång till webbplatsen är gratis förutom den del som är relaterad till kostnaden för
			anslutning via det telekommunikationsnät som tillhandahålls av Internet
			åtkomstleverantör som du har kontrakterat. Du kan fritt surfa på webbplatsen
			och få tillgång till den så många gånger du vill. För att komma åt och navigera på webbplatsen,
			du behöver inte registrera dig, förutom om du vill anlita en tjänst.
		</p>
		<p>
			Användningen av webbplatsen ger dig villkoret för användare av webbplatsen
			(hädanefter "Användaren") och innebär ditt fullständiga och oreserverade godkännande av
			dessa användningsvillkor, såväl som {privacyPolicyLink} och {cookiesPolicyLink}
			av webbplatsen. Dessutom samtycker du till att inte använda Tjänsten för olagligt
			syften.
		</p>
		<p>
			Genom att gå in på webbplatsen och surfa på den deklarerar du under din
			ansvar för att du är myndig och att du har nödvändig juridisk
			kapacitet att få tillgång till webbplatsen och använda den, även försäkra dig om att du fullt ut
			förstå och acceptera dessa användningsvillkor utan förbehåll.
		</p>
		<p>
			Å andra sidan informerar vi dig om att vi av juridiska skäl arkiverar
			elektroniska dokument där köpen formaliseras. Du kan komma åt
			dessa dokument när som helst genom att begära dem på: {supportLink}.
		</p>
		<h3>4. VILLKOR FÖR ANVÄNDNING AV WEBBPLATSEN</h3>
		<p>
			Användaren samtycker till att använda webbplatsen i enlighet med dessa användningsvillkor,
			gällande lagstiftning och god tro. Således kommer användaren att svara på {siteName}.
			 och inför tredje part för skador och förluster som härrör från
			användningen som strider mot dessa villkor, den lagstiftning och den goda tro som gjorts
			av användaren av webbplatsen.
		</p>
		<h3>5. BESKRIVNING AV TJÄNSTEN</h3>
		<p>
			Genom tjänsten tillåter {siteName} att prenumerera på tjänsten
			utföra bildredigering.
		</p>
		<p>
			Språket på vilket avtalet mellan {siteName} och köparen
			kommer att ingås kommer att vara ursprungslandet.<br />
			Köpprocessen i onlinetjänsten kommer att vara följande:
		</p>
		<ol>
			<li>Du måste registrera dig på webbplatsen med ett användarnamn och lösenord.</li>
			<li>
				Vid tidpunkten för registreringen måste användaren välja en av betalningsplanerna
				finns i avsnittet Priser och kommer att beviljas krediter beroende på
				vald plan. Varje kredit ger dig möjlighet att redigera en bild.
			</li>
			<li>
				Efter köpet av tjänsten kommer användaren att ha en administration
				panel där de hittar:
				<ul>
					<li>
						En sektion med en lista över alla bilder som har bearbetats
						kan redigera den så många gånger du vill och ladda ner den till din
						enhet.
					</li>
					<li>
						Ett avsnitt av Planer och betalningar för att konsultera fakturorna och annullera
						prenumeration.
					</li>
					<li>En del av Mitt konto för att kunna ändra kontoinställningar.</li>
				</ul>
			</li>
		</ol>
		<p>
			När köpet av tjänsten har gjorts kommer det att bekräftas av
			skicka ett e-postmeddelande, inom högst 24 timmar, till den adress du har
			anges. Det kommer att indikera tjänsten, hur man avbryter prenumerationen, dess
			belopp, tillämpliga skatter, betalningsform och tillämpliga villkor och
			betingelser.
		</p>
		<h4>5.1 Prenumeration</h4>
		<p>
			Serviceprenumerationen varierar beroende på vald plan och kommer att vara
			automatiskt förnyas för samma tidsperiod fram till dess upphörande.
			Såvida du inte säger upp din prenumeration godkänner du oss att ladda
			motsvarande årlig prenumerationsavgift i din betalningsmetod.
		</p>
		<p>
			Du kan när som helst säga upp din prenumeration på Tjänsten och det kommer du att göra
			fortsätt att ha tillgång till den till slutet av din årliga faktureringsperiod. Till
			i den utsträckning lagen tillåter, är betalningar ej återbetalningsbara och vi tillhandahåller inte
			återbetalningar eller krediter för partiella årsprenumerationsperioder.
		</p>
		<h3>6. PRIS OCH SKATTER</h3>
		<p>
			Priserna på produkterna som erbjuds på {siteName} anges i euro
			(€) eller valutan i det land från vilket köpet görs, Värdet
			Tilläggsskatt (moms) som gäller vid köptillfället tas ut på priset för den
			Produkter.
		</p>
		<p>
			Verksamheten skulle i alla fall kunna vara undantagen eller inte omfattas av moms beroende på
			ditt hemland eller det tillstånd du agerar i. Av denna anledning,
			i vissa fall kan det slutliga priset för beställningen ändras med avseende på
			en visas.<br />
			Inköp gjorda av personer som är befriade från momsbetalning kommer att ange detta med
			skicka sitt VAT/NIF-nummer via e-post till {supportLink}, utan att spela in
			köp med nämnda skatt.
		</p>
		<h3>7. BETALNINGSMETOD</h3>
		<p>
			Onlinebetalning av den köpta tjänsten kan göras med kredit- eller betalkort.
			I detta avseende informerar {siteName} kredit- och betalkortsinnehavare om detta
			transaktioner i webbutiken utförs genom en säker betalning
			gateway, som använder SSL-teknik för att garantera säkerheten för dataöverföring.
		</p>
		<h3>8. ÅTERBERÄTTELSE OCH ÅTERBETALNING</h3>
		<h4>8.1. Ångerrätt</h4>
		<p>
			Med tanke på den typ av produkt som marknadsförs i vår onlinetjänst, programvara i digital
			format av QR kommer ångerrätten inte att gälla enl
			artikel 103, bokstav m) i kungligt lagdekret 1/2007, av den 16 november, av
			den att den reviderade texten till den allmänna lagen för konsumenternas försvar och
			Användare och andra kompletterande lagar är godkända.
		</p>
		<h4>8.2. Återbetalningar</h4>
		<p>
			Oavsett vilken plan som valts av användaren, de belopp som betalas av användaren och till
			den omfattning som lagen tillåter kommer inte att återbetalas.
		</p>
		<p>
			Den avtalade tjänsten får inte tilldelas eller överföras till andra användare av
			tjänsten.
		</p>
		<p>
			I vilket fall som helst kan användaren använda den avtalade tjänsten fram till slutet av
			den avtalade perioden.
		</p>
		<h3>9. ERBJUDANDENAS GILTIGHET</h3>
		<p>
			Tjänsterna som erbjuds i Tjänsten och deras priser kommer att vara tillgängliga för
			köp medan de finns i katalogen över tjänster som visas genom detta
			hemsida.
		</p>
		<p>
			I vilket fall som helst förbehåller sig {siteName} rätten att göra ändringarna
			anser lämpligt i Tjänsten, att kunna uppdatera produkter och tjänster
			beroende på marknaden.
		</p>
		<p>
			{siteName} förbehåller sig rätten att ändra priser utan föregående meddelande. Vi
			informera dig om att trots de uppdateringar som görs av priserna på
			Service, de kan innehålla fel. Vi kommer omedelbart att korrigera eventuella fel som
			visas, men de är inte bindande för Tjänsten.
		</p>
		<h3>10. SÄKERHET</h3>
		<p>
			Som nämnts ovan, hela köpproceduren, såväl som överföringen
			av dina personuppgifter och betalningssystem, utförs på en säker sida och
			på ett krypterat sätt genom SSL-protokollet.
		</p>
		<p>
			Vi garanterar Tjänstens säkerhet i enlighet med gällande
			teknisk kunskap. {siteName} kan dock inte garantera hela
			framtida säkerhet för tjänsten. I vilket fall som helst, vi lovar att korrigera och
			genomföra lämpliga korrigerande åtgärder för att korrigera en eventuell säkerhet
			överträdelse så snart som möjligt.
		</p>
		<p>
			Du samtycker till att meddela {siteName} omedelbart och via e-post {supportLink}
			av alla situationer som kan leda till att en användares identitet efterliknas.
		</p>
		<h3>11. ÄNDRINGAR OCH NULLITET</h3>
		<p>
			Vi kan komma att uppdatera villkoren för tjänsten i framtiden också
			som funktioner och funktioner för själva tjänsten.
		</p>
		<p>
			Vi kommer att informera dig om ändringarna i villkoren genom att lägga ett meddelande
			på en framträdande plats på vår hemsida och/eller via e-post.
		</p>
		<p>
			Om någon klausul som ingår i dessa villkor deklareras, helt eller
			delvis, ogiltig eller ineffektiv, kommer det endast att påverka nämnda bestämmelse eller delen
			av det som är ogiltig eller ineffektivt. Villkoren kommer att gälla
			allt annat, att ha sådan bestämmelse, eller den del av den som berörs, av
			inte placeras.
		</p>
		<h3>12. ANSPRÅK OCH ÅTGÄRDER SOM HELDER FRÅN KONTRAKTET</h3>
		<p>
			Så långt det är möjligt regleras denna tjänst av spansk lag.<br />
			För att förenkla lösningen av anspråk genom civilrättsliga förfaranden och
			minska kostnaderna utesluter vi inte möjligheten att underkasta oss en
			Equity Skiljedom vid Handelskamrarnas skiljedomstol och
			Industri. I denna mening, och enligt tillämpliga bestämmelser,
			 {siteName} informerar om att det finns en europeisk tvistlösning online
			plattform som underlättar utomrättslig lösning av sådana tvister för
			avtal som också ingåtts online mellan konsumenter och Internettjänst
			leverantörer. Denna plattform kan nås via följande webbplats:
			<a href="http://ec.europa.eu/odr" target="_blank">http://ec.europa.eu/odr</a>
		</p>
		<h3>13. IMMATERIELLA OCH INDUSTRIELLA RÄTTIGHETER</h3>
		<p>
			Webbplatsen och dess innehåll är föremål för skydd vid tillämpning av
			gällande nationella bestämmelser om immateriell och/eller industriell äganderätt, som
			samt vid tillämpning av de internationella konventioner som är tillämpliga i sådana
			frågor. {siteName} är ägare eller har vederbörligen licensierat alla
			Immateriella och industriella rättigheter på webbplatsen och dess innehåll.
		</p>
		<p>
			Varje form av reproduktion, distribution, offentlig kommunikation, transformation,
			tillgängliggörande och i allmänhet varje annan exploatering, oavsett om den är tillgänglig eller inte
			för kommersiella ändamål av webbplatsen eller dess innehåll, utan föregående
			uttryckligt samtycke från {siteName}. Det är uttryckligen förbjudet att radera
			identifiera data för {siteName} som ägare till den intellektuella och
			Industriella äganderätter för webbplatsen eller dess innehåll.
		</p>
		<p>
			{siteName} förbehåller sig alla immateriella och industriella rättigheter
			över webbplatsen och dess innehåll, med förbehåll för utövandet av eventuella juridiska
			åtgärder som motsvarar det för att upphöra, förhindra eller åtala någon
			olaglig användning av webbplatsen eller dess innehåll. I inget fall och under nr
			omständigheter gör åtkomst till webbplatsen eller dess användning av användaren eller tredje
			parter utgör eller antyder en överlåtelse av något slag av {siteName} av
			de immateriella eller industriella rättigheterna till webbplatsen eller dess innehåll.
			I inget fall avsaknaden av krav från {siteName} att sluta använda
			Webbplatsen eller dess olagliga eller innehåll som strider mot dessa villkor kan vara
			uppfattas som ett tyst samtycke från {siteName} till sådan användning eller som ett avstående
			av utövandet av alla rättsliga åtgärder som kan motsvara det.
		</p>
		<h3>14. ANSVAR OCH GARANTIER</h3>
		<p>
			Användaren måste använda webbplatsen och dess innehåll i enlighet med
			bestämmelserna i dessa användningsvillkor, gällande lagstiftning och god tro. Några
			användning av webbplatsen eller dess innehåll i strid med dessa allmänna villkor
			lag eller god tro är uttryckligen förbjudet, oavsett om nämnda användning har
			ett ekonomiskt syfte eller inte.<br />
			Användaren kommer att vara ansvarig för eventuell skada som orsakas av {siteName}
			 eller till tredje part som härrör direkt eller indirekt från någon användning
			som Användaren gör av Webbplatsen eller dess innehåll i strid med dessa
			villkor, lag, sedlighet, allmän ordning eller god tro.
		</p>
		<p>
			För att webbplatsen och dess innehåll ska vara tillgänglig för användaren, {siteName}
			 kräver tjänster som tillhandahålls av tredje part. Är det möjligt att
			trots de ansträngningar som {siteName} gjort för att hålla webbplatsen tillgänglig
			och tillgänglig för användare, dess tillgänglighet kan stängas av, avbrytas eller
			avbröts av andra skäl än {siteName}. Det är därför {siteName}
			garanterar inte frånvaron av avbrott eller fel vid åtkomst till
			Webbplatsen eller dess innehåll, inte heller att de är uppdaterade eller alltid visas i
			deras senaste version. Följaktligen avvisar {siteName} alla
			ansvar för skador som kan härledas till Användaren eller tredje part som
			ett resultat av avstängningen, avbrott, bristande kontinuitet, nätverksavbrott
			eller frånkoppling av webbplatsen.
		</p>
		<p>
			I inget fall och under inga omständigheter kommer {siteName} att vara ansvarigt för
			skador eller förluster som härrör användaren från orsaker som inte kan tillskrivas {siteName}
			 såsom, som exempel och inte i något fall begränsande, naturliga
			katastrofer, situationer av force majeure eller extrem brådska, virus, skadliga
			komponenter, webbläsarfel, nätverksavbrott, datorintrång eller
			tredjepartsattacker.
		</p>
		<h3>15. LÄNKAR</h3>
		<p>
			De webbplatser, plattformar, forum, chattar, bloggar eller externa sociala nätverk som
			länk eller länk till webbplatsen måste tydligt informera om att de inte har
			auktorisering eller övervakning av {siteName} och att nämnda länkning eller
			länken innebär inte, förutsätter eller antyder koppling av något slag mellan {siteName}
			 och webbplatser, plattformar, forum, chattar, bloggar eller externa
			sociala nätverk som länkar eller länkar till webbplatsen.
		</p>
		<p>
			I vilket fall som helst måste alla länkar som är avsedda för webbplatsen riktas
			direkt till hemsidan eller hemsidan genom att klicka på URL:en
			av webbplatsen som täcker hela skärmen på startsidan eller startsidan
			webbplatsen, så att länken är absolut och komplett utan användning av
			ramar, ramar eller hyperlänkar. {siteName} svarar inte i något fall
			och under alla omständigheter till innehållet, informationen eller data relaterade till
			webbplatsen, dess innehåll eller något annat som finns på webbplatserna, plattformarna,
			forum, chattar, bloggar eller sociala nätverk från tredje part som länkar eller länkar till
			Hemsida.
		</p>
		<p>
			Det är uttryckligen förbjudet att länka eller länka till webbplatsen från webbplatser,
			plattformar, forum, chattar, bloggar eller sociala nätverk som strider mot lagen, moralen
			och goda seder, särskilt de med pornografiska, olagliga, olagliga eller
			kränker innehållet i mänskliga rättigheter.
		</p>
		<p>
			Å andra sidan kan webbplatsen innehålla länkar till tredje parts webbplatser,
			plattformar, forum, chattar, bloggar eller sociala nätverk. {siteName} gör det inte
			ha mänskliga och/eller tekniska medel att känna till eller kontrollera informationen och
			innehåll som visas på tredje parts webbplatser. Därför kommer {siteName} inte i något fall
			 vara ansvarig för innehållet på de länkade webbplatserna och under nr
			omständigheter kan nämnda länkar anses vara effektiv kunskap om innehållet
			av de webbplatser som de länkar till.
		</p>
		<h3>16. DATASKYDD</h3>
		<p>
			Som fastställts i sin {privacyPolicyLink} åtar sig {siteName} att använda Användare
			data, att respektera dess konfidentialitet och att använda dem i enlighet med
			syftet med behandlingen, samt att uppfylla sin skyldighet att spara den.
			och anpassa alla åtgärder för att undvika förändring, förlust, behandling eller obehörig
			tillträde i enlighet med bestämmelserna i gällande lagstiftning angående den
			skydd av personuppgifter.
		</p>
		<p>
			Webbplatsen innehåller lämpliga skyddsåtgärder och använder industristandard
			teknik för att förbättra säkerheten, integriteten, fullständigheten, noggrannheten och
			skydd av de personuppgifter som den har samlat in och har fastställt
			rimliga försiktighetsåtgärder för att skydda den informationen från eventuell förlust eller
			missbruka. Dess regler om dataskydd och säkerhet ses över med jämna mellanrum
			och förbättras när det behövs, och det strävar efter att säkerställa att endast auktoriserade
			personer kan komma åt den information som användaren tillhandahåller.
		</p>
		<p>
			Om du vill veta mer om hanteringen och behandlingen som utförs av {siteName}
			 av dina data, läs vår {privacyPolicyLink} och vår {cookiesPolicyLink}.
		</p>
		<h3>17. VARAKTIGHET OCH ÄNDRING</h3>
		<p>
			Dessa användningsvillkor kommer att gälla så länge de utsätts för
			användare, så att så snart de är helt eller delvis modifierade eller uppdaterade,
			dessa villkor kommer att upphöra att gälla, eftersom de är de nya villkoren för användning
			de som fortsätter att reglera användningen av webbplatsen.
		</p>
		<p>
			{siteName} förbehåller sig rätten att granska, ändra eller uppdatera dessa
			användningsvillkor när som helst. Vid eventuell ändring av dessa villkor
			för användning av någon anledning kommer {siteName} att meddela användarna på startsidan om
			webben om nämnda omständighet så att de är vederbörligen informerade och kan konsultera
			revisionerna, ändringarna eller uppdateringarna av de nuvarande användarvillkoren till
			din tillfredsställelse.
		</p>
		<h3>18. ALLMÄNT</h3>
		<p>
			I inget fall och under inga omständigheter får bristen på utövandet av dina rättigheter
			av {siteName} förstås som ett avstående från dem.
		</p>
		<p>
			Rubrikerna i dessa villkor är endast vägledande eller
			informativa, så att de inte påverkar, kvalificerar eller utökar tolkningen
			därav.
		</p>
		<p>
			I händelse av att någon av klausulerna i dessa villkor var
			förklarats ogiltig, missbrukande eller omöjlig att verkställa, helt eller delvis, av en domstol
			eller administrativt organ, kommer nämnda förklaring individuellt att påverka klausulen
			ifrågavarande, tar det som inte och utan ogiltigförklaring, missbruk eller
			otillämplighet utvidgas under några omständigheter till resten av
			förhållanden som kommer att bestå.
		</p>
		<p>
			Dessa användarvillkor, samt {privacyPolicyLink} och {cookiesPolicyLink}
			styrs av gällande spanska regler vid alla tillfällen.
		</p>
		<h3>19. KUNDSERVICE</h3>
		<p>
			För alla förtydliganden, incidenter eller anspråk kan du kontakta oss via:<br />
			E-post: {supportLink}<br />
			Postadress: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.
		</p>`
	},
	privacyPolicy: {
		lastUpdate: 'Senast uppdaterad: 10 juni 2024',
		content: `
			<h3>1. Ansvarig part och beskrivning</h3>
			<h5>1.1. Ansvarig</h5>
			<p>Den person som är ansvarig för behandlingen av denna webbplats är Remove Background S.L (nedan kallat Remove Background 
			eller tjänsten), med adress på Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
			<p>NIF: B56768260<br> E-post: {supportLink}</p>

			<h5>1.2. Beskrivning</h5>
			<p>Godkännande av integritetspolicyn för Remove Background (hädanefter "Sekretesspolicy") är ett nödvändigt villkor 
				för användningen av vår webbplats och tillhandahållandet av tjänsten (nedan kallad "Tjänsten").<br>
				Denna integritetspolicy reglerar insamling, behandling och användning av din personliga och icke-personliga information 
				som användare av Ta bort bakgrund, från och med giltighetsdatumet som visas i rubriken.<br>
				För att behandla dina personuppgifter följer Remove Background gällande lokal och europeisk lagstiftning, 
				samt dess tillämpningsföreskrifter.</p>


			<h3>2. Information som samlats in</h3>
			<p>Åtkomst till vår webbplats kan göras utan att du behöver lämna någon information, även om du registrerar dig och/ 
				eller avtala våra planer måste du förse oss med viss personlig information. Informationen (personlig 
				eller icke-personligt) som samlas in av tjänsten kan variera beroende på det.<br>
				Den personliga och icke-personliga information som samlas in av Tjänsten kommer till oss på tre sätt: 1) det som 
				samlas in automatiskt 2) det som du tillhandahåller oss frivilligt och 3) det som tillhandahålls av tredje part.</p>

			<h5>2.1. Den som samlas in automatiskt</h5>
			<p>Denna information kommer att bestå av:</p>
			<ul>
				<li>Den som samlas in genom cookies eller liknande mekanismer som lagras på din enhet, alltid med ditt samtycke eller i 
					i enlighet med andra rättsliga grunder. Se vår cookiepolicy för mer information.</li>
				<li>IP-adressen från vilken anslutningen görs, typen av enhet som används och dess egenskaper, versionen av 
					operativsystemet, typen av webbläsare, språket, datumet, landet, tidpunkten för begäran, 
					URL:en från den du kommer ifrån, URL:en som du går till eller det mobilnät som du använder, bland annat.</li>
				<li>Data för tjänstanvändning och möjliga fel som upptäckts under användningen.</li>
				<li>Dessutom använder Remove Background Google Analytics, en analystjänst som tillhandahålls av Google, LLC. 
					hemvist i USA med huvudkontor på 1600 Amphitheatre Parkway, Mountain View, Kalifornien 94043. 
					För tillhandahållandet av dessa tjänster använder de cookies som samlar in information, inklusive användarens IP-adress, 
					som kommer att överföras, bearbetas och lagras av Google i de villkor som fastställs på webben www.google.com. 
					Inklusive eventuell överföring av nämnda information till tredje part på grund av lagkrav eller 
					när nämnda tredje part behandlar informationen på uppdrag av Google.</li>
			</ul>
			<p>Du kan i alla fall inaktivera Google Analytics-cookies från <a href="{externalLink: disableGoogleAnalyticsLink}">här</a>.</p>

			<h5>2.2. Den du frivilligt tillhandahåller</h5>
			<p>Denna information kommer att bestå av:</p>
			<ul>
				<li>All data är obligatorisk.</li>
				<li>Den som krävs av Remove Background för att slutföra din registrering på webben: bland annat namn och efternamn, adress och e-postadress.</li>
				<li>All data är obligatorisk.</li>
				<li>Informationen, personlig eller inte, för att slutföra kontraktet för tjänsten, såsom din e-postadress och ditt kredit- eller betalkortsnummer.</li>
				<li>Den information, personlig eller inte, som meddelanden som skickas via kontakt- eller opinionskanalerna som är etablerade i tjänsten kan innehålla, 
					till exempel ditt namn och din e-postadress.</li>
			</ul>

			<h5>2.3. Den som tillhandahålls av tredje part</h5>
			<p>Denna information kommer att bestå av:</p>
			<ul>
				<li>Den som tillhandahålls av betalningssystem eller kreditkortsprocessorer, till exempel tidpunkten för köpet eller dess belopp.</li>
			</ul>


			<h3>3. Rättigheter och syften</h3>
			<p>Vi informerar dig om att det är frivilligt att fylla i formulären. Men om du inte fyller i de obligatoriska fälten 
				(vanligtvis markerad med en asterisk), kommer användningen av vissa funktioner i tjänsten inte att vara möjlig eller kommer att vara begränsad.<br>
				De personuppgifter som du tillhandahåller oss kommer att införlivas och behandlas i registret för behandlingsaktiviteter med borttagningsbakgrund 
				för att kunna tillmötesgå dina förfrågningar, tillhandahålla den efterfrågade tjänsten och hålla dig informerad om ärenden relaterade till aktiviteten 
				av företaget och dess tjänster.<br>
				Du kan när som helst utöva rätten till åtkomst, rättelse, radering, begränsning av din behandling, 
				opposition och portabilitet av dina personuppgifter via e-post adresserad till: {supportLink} eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.<br>
				I båda fallen måste du identifiera dig med ditt namn och efternamn, samt en kopia av ditt DNI eller nationellt ID, om det behövs.<br>
				I händelse av att du har lämnat samtycke för ett specifikt ändamål har du rätt att när som helst återkalla ditt samtycke, 
				utan att det påverkar lagligheten av behandlingen baserat på samtycket före dess återkallande.<br>
				Dessutom, om du anser att det finns ett problem med det sätt på vilket Remove Background hanterar dina data, 
				du kan rikta dina klagomål till motsvarande <a href="{knowYourRightsLink}">dataskyddsmyndighet</a>, som är den <a href="{aepdLink}">spanska myndigheten för dataskydd</a> 
				den som anges i fallet med Spanien.</p>


			<h3>4. Ålder</h3>
			<p>Beträffande användningen av onlinetjänsten intygar du att du är myndig och att du har de nödvändiga juridiska 
				förmåga att vara bunden av detta avtal och använda webbplatsen i enlighet med dess villkor, som du fullt ut 
				förstå och erkänna.<br>
				Du försäkrar att all information du tillhandahåller för att komma åt Tjänsten, före och under dess användning, är sann, fullständig 
				och korrekt.</p>


			<h3>5. Användning av data</h3>
			<p>Ta bort bakgrund kommer att använda den insamlade informationen för att:</p>
			<ul>
				<li>Hantera och uppdatera tjänsten (den rättsliga grunden är vårt legitima intresse av att underhålla och behålla tjänsten 
					uppdaterad och i gott skick).</li>
				<li>Behandla de frågor du ställer (den rättsliga grunden är vårt berättigade intresse av att svara på förfrågningarna och 
					våra användares tvivel).</li>
				<li>Behandla de betalningar du gör (kontraktet är den rättsliga grunden).</li>
				<li>Tillhandahålla den avtalade tjänsten (kontraktet är den rättsliga grunden).</li>
				<li>Upprätthåll Tjänstens säkerhet, undersök olagliga aktiviteter, upprätthåll våra villkor och
					hjälpa de statliga säkerhetsstyrkorna inom ramen för deras eventuella utredningar (den rättsliga grunden är vår 
					legitimt intresse av att garantera och upprätthålla säkerheten för Tjänsten och dess användare).</li>
			</ul>
			<p>Ta bort bakgrund använder inte automatiska beslut, även om det kan generera grundläggande användarprofiler, 
				den rättsliga grunden är vårt berättigade intresse för kommersiella ändamål och tillhandahållande av personliga erbjudanden.<br>
				Dessutom kan Remove Background använda användarinformation i form av aggregerad och anonym data för att visa den för tredje part. 
				Du kan också dela statistik och demografisk information om användare och deras användning av tjänsten med tredje part. 
				Men inget av detta kommer att tillåta dessa tredje parter att personligen identifiera dig.</p>

			<h5>5.1. I mejl och kontaktformulär</h5>
			<p>Webbplatsen har en SSL-kryptering som gör det möjligt för användaren att skicka sina personuppgifter säkert via vanliga kontaktformulär.<br>
				De insamlade personuppgifterna kommer att bli föremål för automatisk behandling och införlivas i motsvarande filer 
				av register över bearbetningsaktiviteter och som Remove Background är ägare till.</p>
			<p>I den meningen:</p>
			<ul>
				<li>Vi kommer att få din IP-adress, som kommer att användas för att verifiera meddelandets ursprung för att kunna erbjuda dig tillräcklig 
					rekommendationer (till exempel presentera informationen på rätt språk) och för att upptäcka eventuella oegentligheter 
					(till exempel möjliga försök att cyberattacka tjänsten), samt data relaterade till din internetleverantör.</li>
				<li>På samma sätt kan du förse oss med dina uppgifter via telefon, e-post och andra angivna kommunikationsmedel.</li>
			</ul>
			<p>Angående det använda betalningsmedlet:</p>
			<ul>
				<li>Våra betaltjänstleverantörer för att betala för tillhandahållandet av våra tjänster är kredit- eller betalkort. 
					Tjänsten eller dess personal kommer aldrig att ha tillgång till bankuppgifterna (till exempel kreditkortsnumret) 
					som användaren som kund kommer att tillhandahålla dessa tredje parter.</li>
			</ul>


			<h3>6. Datalagring</h3>
			<p>Nedan anges de hur länge uppgifterna som behandlas av Tjänsten sparas:</p>
			<ul>
				<li>De uppdelade uppgifterna kommer att bevaras utan en raderingsperiod.</li>
				<li>
					Kunddata kommer att bevaras så långt det är nödvändigt och kan bevaras tills:
					<ul>
						<li>5 år, enligt art. 1964 i civillagen (personliga handlingar utan särskild tid).</li>
						<li>6 år, enligt art. 30 i handelsbalken (till exempel bokföringsböcker eller fakturor).</li>
					</ul>
				</li>
				<li>Användardata kommer att sparas i högst 12 månader för att kunna tillmötesgå deras förfrågningar.</li>
			</ul>


			<h3>7. Data som delas med tredje part</h3>
			<p>Det finns tredje parter som hanterar en del av tjänsten.<br>
				Ta bort bakgrund kräver att de följer denna sekretesspolicy i tillämpliga fall, förutom att de har sin egen. Remove Background kommer dock inte att ansvara för efterlevnaden av nämnda policy.<br>
				Under vissa omständigheter kan Remove Background dela, använda eller bevara någon av de insamlade personliga uppgifterna med tredje part:</p>
			<ul>
				<li>För att tillhandahålla tjänsten:</li>
			</ul>
			<p>Tjänsteleverantörer som utför funktioner för vår räkning, såsom betaltjänster, webbhotell, affärsanalys, kundtjänst eller webbmarknadsföring. Dessa tjänsteleverantörer kan samla in och ha tillgång till den information som är nödvändig för att de ska kunna utföra sina funktioner, men de får inte dela eller använda informationen för något annat ändamål.</p>
			<ul>
				<li>Att samarbeta med de behöriga myndigheterna:</li>
			</ul>
			<p>Om vi anser att det rimligen är nödvändigt för att tillgodose någon lag, juridisk process eller berättigat intresse. I vilket fall som helst kommer vi bara att tillhandahålla den information som strikt krävs.</p>


			<h3>8. Säkerhetsåtgärder</h3>
			<p>Ta bort bakgrund vidtar alla tekniska och organisatoriska åtgärder som krävs för att
				skydda säkerheten och integriteten för personlig och icke-personlig information som samlas in. 
				Både mot obehörig åtkomst och dess oavsiktliga ändring, förlust eller förstörelse.<br>
				Under alla omständigheter kan Remove Background inte garantera den absoluta säkerheten för den insamlade informationen, 
				så du måste samarbeta och använda sunt förnuft om informationen som delas hela tiden.<br>
				Du förstår och erkänner att även efter radering kan personlig och icke-personlig information 
				förbli synliga i cachen eller om andra användare har kopierat eller lagrat det.</p>


			<h3>9. Ändringar av integritetspolicyn</h3>
			<p>Vi kan komma att uppdatera denna sekretesspolicy i framtiden. Vi kommer att informera dig om ändringarna genom att skicka ett meddelande till den angivna e-postadressen och/eller genom att placera ett meddelande på en framträdande plats på vår webbplats.</p>


			<h3>10. Kontakta</h3>
			<p>Om du har frågor om denna sekretesspolicy, kontakta oss på:</p>
			<p>E-post: {supportLink}<br> 
				Adress: Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
		`
	},
	gdpr: {
		lastUpdate: 'Senast uppdaterad: 10 juni 2024',
		content: `
			<h3>1. Vem är ansvarig och hur kontaktar man dem?</h3>
			<p>Kontrollansvarig för denna webbplats är Remove Background S.L med adress Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien.</p>
			<p>Du kan kontakta honom via e-post på {supportLink}.</p>

			<h3>2. Vilken data samlas in?</h3>
			<p>
				Vi samlar automatiskt in data via cookies som vi laddar på din enhet, inklusive analyser. 
				Vi samlar också in den IP från vilken anslutningen görs, vilken typ av enhet som används och dess egenskaper, 
				versionen av operativsystemet, typen av webbläsare, språket, datumet, landet, tidpunkten för begäran, 
				webbadressen som du kommer ifrån, webbadressen du går till eller det mobilnät som du använder, bland annat.<br>
				Frivilligt ger användaren oss viss information såsom hans namn och efternamn, e-post eller bankinformation 
				för att kunna kontakta oss, registrera dig för tjänsten eller köpa ett abonnemang.
			</p>

			<h3>3. Vad används den insamlade informationen till?</h3>
			<p>
				Tjänsten kommer att använda de insamlade uppgifterna, bland annat för att administrera och uppdatera tjänsten, svara på dina förfrågningar, 
				skicka dig vårt nyhetsbrev och kampanjerbjudanden via e-post, hantera din registrering på plattformen, hantera och tillhandahålla 
				tjänsterna relaterade till ditt abonnemang, behandla betalningarna du gör och utfärda motsvarande fakturor, 
				upprätthålla tjänstens säkerhet, undersöka olaglig verksamhet, upprätthålla våra villkor och 
				hjälpa de statliga säkerhetsstyrkorna och organen inom ramen för deras eventuella utredningar.
			</p>

			<h3>4. Hur länge sparas de?</h3>
			<ul>
				<li>De uppdelade uppgifterna kommer att bevaras utan en raderingsperiod.</li>
				<li>
					Kunddata kommer att bevaras så långt det är nödvändigt och kan bevaras tills:
					<ul>
						<li>5 år, enligt art. 1964 i civillagen (personliga handlingar utan särskild tid).</li>
						<li>6 år, enligt art. 30 i handelsbalken (till exempel bokföringsböcker eller faktura).</li>
					</ul>
				</li>
				<li>Användardata kommer att sparas i högst 12 månader för att kunna tillmötesgå deras förfrågningar.</li>
				<li>Användardata som laddas upp av Tjänsten till sidor och profiler på sociala nätverk kommer att sparas från det ögonblick användaren ger sitt samtycke tills han drar tillbaka det.</li>
			</ul>

			<h3>5. Vilka rättigheter har du som användare?</h3>

			<p>
				Rätt till insyn: Den berörda parten ska ha rätt att få bekräftelse från den personuppgiftsansvarige om 
				eller inte personuppgifter som rör honom eller henne behandlas.
			</p>
			<p>
				Rätt till rättelse: den berörda parten ska ha rätt att utan onödigt dröjsmål få den personuppgiftsansvarige 
				rättelse av personuppgifter som är felaktiga och som berör honom direkt. Likaså kommer den berörda parten 
				har rätt att komplettera ofullständiga personuppgifter, inklusive genom en tilläggsdeklaration.
			</p>
			<p>
				Rätt till radering: Det är den berörda partens rätt att utan onödigt dröjsmål få raderingen av den personuppgiftsansvarige 
				av de personuppgifter som rör honom.
			</p>
			<p>
				Rätt att begränsa databehandling: består i att få begränsningen av behandlingen av dina uppgifter av den ansvariga personen, 
				även om dess utövande har två aspekter: 1) När du ifrågasätter riktigheten av dina personuppgifter, under en period som tillåter 
				ansvarig för att verifiera det och 2) När du har invänt mot behandlingen av dina personuppgifter som ansvarig person 
				utför baserat på berättigat intresse eller ett uppdrag av allmänt intresse, medan den ansvarige kontrollerar om dessa skäl 
				segra över din.
			</p>
			<p>
				Rätt till dataportabilitet: Det är den berörda partens rätt att få de personuppgifter som berör honom, 
				som han har lämnat till en personuppgiftsansvarig, i ett strukturerat format, av allmänt bruk och mekanisk läsning, och 
				att överföra dem till en annan kontrollant utan att hindras av den registeransvarige till vilken de tillhandahållits.
			</p>
			<p>
				I denna mening kommer den berörda parten att ha rätt att få personuppgifter överförda direkt från den registeransvarige 
				till styrenhet när det är tekniskt möjligt.
			</p>

			<h3>6. Hur kan du utöva dina rättigheter?</h3>

			<p>
				Du kan utöva dina personuppgifter när som helst genom att skicka ett e-postmeddelande till: {supportLink} Eller postadressen: 
				Av. Cerdanyola, 75 - 1º, CP 08172, Sant Cugat del Vallés, Barcelona, Spanien. I båda fallen måste du identifiera dig med ditt namn och efternamn, 
				samt en kopia av ditt DNI eller nationella ID, om det behövs.<br>
				Dessutom, om du anser att det finns ett problem med hur Remove Background hanterar din data, kan du rikta dina anspråk 
				till <a href="{knowYourRightsLink}">dataskyddsmyndigheten</a> som motsvarar, som är den <a href="{aepdLink}">spanska myndigheten för dataskydd</a> 
				den som anges i fallet med Spanien.
			</p>

			<h3>7. Antas säkerhetsåtgärder?</h3>
			<p>
				Tjänsten vidtar alla nödvändiga tekniska och organisatoriska åtgärder för att skydda personlighetens säkerhet och integritet 
				och icke-personlig information som samlas in. Både mot obehörig åtkomst och oavsiktlig ändring, förlust eller förstörelse.<br>
				Under alla omständigheter kan Tjänsten inte garantera den absoluta säkerheten för den information som samlas in, så du måste samarbeta och 
				använd sunt förnuft när det gäller delad information.<br>
				Du förstår och erkänner att, även efter radering, kan personlig och icke-personlig information förbli synlig i cache eller 
				om den kopieras eller lagras av andra användare.
			</p>

			<h3>8. Finns det överföringar av personuppgifter eller internationella överföringar?</h3>

			<p>
				Vi överför inte data eller internationella överföringar. Det finns dock tredje parter som hanterar en del av Tjänsten 
				att vi kräver att följa vår integritetspolicy i den mån den är tillämplig på dem och att de har sin egen. 
				Dessa tredje parter är tjänsteleverantörer som utför funktioner för vår räkning, såsom webbhotell, 
				analysövervakning eller webbutveckling.<br>
				Dessutom, om vi anser att det rimligen är nödvändigt för att tillgodose någon lag, juridisk process eller berättigat intresse. 
				I vilket fall som helst kommer vi bara att tillhandahålla den strikt nödvändiga informationen.
			</p>

		`
	},
	cookiesPolicy: {
		lastUpdate: 'Senast uppdaterad: 21 juni 2024',
		content: `
			<h3>Sammanfattning</h3>
			<ul>
			    <li>Använda cookies: <strong>Egen och tredje part</strong></li>
			    <li>Används de för att få statistik? <strong>Ja, baserat på vårt berättigade intresse av att bättre hantera tjänsten.</strong></li>
			    <li>Tredjepartstjänster som installerar cookies via denna webbplats: <strong>Google, Google Analytics, Cloudflare och Stripe.</strong></li>
			</ul>

			<h3>Hur man konfigurerar och inaktiverar cookies</h3>
			<p>
			    Du kan tillåta, blockera eller ta bort cookies som är installerade på din enhet från din webbläsare. Om du inte tillåter att cookies installeras på din enhet, 
			    webbupplevelsen kan förvärras. Nedan kan du se hur du konfigurerar cookies i varje webbläsare:
			</p>
			<ul>
			    <li><a href="{externalLink: edgeCookies}">Edge</a></li>
			    <li><a href="{externalLink: chromeCookies}">Google Chrome</a></li>
			    <li><a href="{externalLink: googleAndroidCookies}">Google Android</a></li>
			    <li><a href="{externalLink: internetExplorer8Cookies}">Internet Explorer 8</a></li>
			    <li><a href="{externalLink: internetExplorer9Cookies}">Internet Explorer 9</a></li>
			    <li><a href="{externalLink: internetExplorer11Cookies}">Internet Explorer 11</a></li>
			    <li><a href="{externalLink: firefoxCookies}">Mozilla Firefox</a></li>
			    <li><a href="{externalLink: operaCookies}">Opera</a></li>
			    <li><a href="{externalLink: safariCookies}">Safari</a></li>
			    <li><a href="{externalLink: safariMobileCookies}">Safari Mobile</a></li>
			</ul>

			<h3>1. Typer och användningsområden</h3>
			<p>Tjänsten använder egna och tredjepartscookies för att förbättra surfning, tillhandahålla tjänsten och få statistik om användningen av webbplatsen.</p>

			<h3>2. Vad är en cookie och vad används den till?</h3>
			<p>
			    En cookie är en textfil som skickas till din dator, mobil eller surfplatta och används för att lagra och hämta information om
			    surfandet gjort. Till exempel för att komma ihåg ditt användarnamn och lösenord eller dina profilinställningar.
			</p>

			<h3>3. Vilka typer av cookies finns det?</h3>
			<p>Beroende på vem som hanterar dem:</p>
			<ul>
			    <li>Egna cookies; de skickas till din webbläsare från vår egen utrustning eller webbdomäner.</li>
			    <li>Tredjepartscookies; de skickas till din webbläsare från utrustning eller webbdomäner som vi inte direkt hanterar, utan av en tredje enhet som Google.</li>
			</ul>
			<p>Baserat på hur länge de är aktiva finns det:</p>
			<ul>
			    <li>Sessionscookies; de finns kvar i din webbläsares cookiefil tills du lämnar webbplatsen, så ingen stannar kvar på din enhet.</li>
			    <li>Beständiga cookies; de finns kvar på din enhet och vår webbplats läser dem varje gång du gör ett nytt besök. Dessa cookies slutar fungera efter ett visst datum.</li>
			</ul>
			<p>Slutligen, beroende på deras syfte, har vi:</p>
			<ul>
			    <li>Tekniska cookies; de förbättrar surfningen och att webbplatsen fungerar korrekt.</li>
			    <li>Personliga cookies; de ger tillgång till tjänsten med fördefinierade egenskaper baserat på en rad kriterier.</li>
			    <li>Analytics-cookies; de gör det möjligt att mäta och statistiskt analysera användningen av den tillhandahållna tjänsten.</li>
			</ul>
			<p>Lista över tredjepartscookies som används av <strong>remove-background.com</strong></p>
			<ul>
			    <li>
			        <a href="{externalLink: googleCookiesPolicy}">Google</a>: Deras cookies (NID eller SAMTYCKE) gör det möjligt att anpassa hur annonser visas utanför Google eller lagra information
			        till exempel det föredragna språket vid visning av sökresultat.<br><a href="{externalLink: googleCookieTypes}">Mer information</a> om vilka typer av cookies som Google använder i sina olika tjänster.
			    </li>
			    <li>
			        <a href="{externalLink: googleAnalyticsCookies}">Google Analytics</a>: Deras cookies (som _ga) gör det möjligt att räkna hur många gånger en användare besöker en webbplats, hur, när och varifrån.<br>
			        I vilket fall som helst kan du inaktivera Google Analytics-cookies från <a href="{externalLink: disableGoogleAnalytics}">här</a>.
			    </li>
			    <li>Cloudflare: För att lära dig mer om Cloudflares cookiepolicy och användning, klicka på <a href="{externalLink: cloudflareCookiesPolicy}">den här länken</a>.</li>
			    <li>Stripe: Hitta information <a href="{externalLink: stripeCookiesPolicy}">här</a> om Stripes cookiepolicy och användning.</li>
			</ul>
		`
	}
};
